"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AnnouncementService;

var _react = _interopRequireDefault(require("react"));

var _heading = require("@tdcerhverv/heading");

var _announcementGetIcon = require("./../announcementGetIcon");

var _Close = _interopRequireDefault(require("@tdcerhverv/parrotfish/dist/icons/Icons/Close.svg"));

var _icon = require("@tdcerhverv/icon");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

require("./../styles/AnnouncementService.module.scss");

var styles = {
  "announcement__service": "AnnouncementService-module__announcement__service___3ZocS",
  "announcement__service__icon": "AnnouncementService-module__announcement__service__icon___3-ecd",
  "announcement__service__icon__close": "AnnouncementService-module__announcement__service__icon__close___1xZ5J AnnouncementService-module__announcement__service__icon___3-ecd",
  "announcement__service__heading": "AnnouncementService-module__announcement__service__heading___28rLJ",
  "announcement__service__message": "AnnouncementService-module__announcement__service__message___18omf",
  "announcement__service__link": "AnnouncementService-module__announcement__service__link___10g_y"
};

require("./../styles/AnnouncementColors.module.scss");

var colors = {
  "announcement__info": "AnnouncementColors-module__announcement__info___NegJf",
  "announcement__positive": "AnnouncementColors-module__announcement__positive___3hEC8",
  "announcement__negative": "AnnouncementColors-module__announcement__negative___3TYWe",
  "announcement__warning": "AnnouncementColors-module__announcement__warning___8JMT5"
};

function AnnouncementService(_ref) {
  var _cn;

  var type = _ref.type,
      title = _ref.title,
      message = _ref.message,
      link = _ref.link,
      linkText = _ref.linkText,
      linkTarget = _ref.linkTarget,
      onClose = _ref.onClose,
      className = _ref.className;
  var SVGIcon = (0, _announcementGetIcon.getIcon)(type);
  var containerClasses = (0, _classnames.default)(styles.announcement__service, (_cn = {}, _defineProperty(_cn, colors.announcement__info, type === 'info'), _defineProperty(_cn, colors.announcement__positive, type === 'positive'), _defineProperty(_cn, colors.announcement__negative, type === 'negative'), _defineProperty(_cn, colors.announcement__warning, type === 'warning'), _cn), className);
  return _react.default.createElement("div", {
    className: containerClasses
  }, _react.default.createElement(_icon.Icon, {
    icon: SVGIcon //name='announcement icon' HACK: temporarily removed, together with related unit-tests
    ,
    className: styles.announcement__service__icon
  }), _react.default.createElement("span", {
    className: styles.announcement__service__message
  }, _react.default.createElement(_heading.Heading.H4, {
    weight: "strong",
    className: styles.announcement__service__heading
  }, title), message, link && linkText && "\xA0", link && linkText && _react.default.createElement("a", {
    href: link,
    className: styles.announcement__service__link,
    target: linkTarget || '_self'
  }, linkText)), onClose && _react.default.createElement(_icon.Icon, {
    icon: _Close.default,
    size: "xs" //name="announcement close icon" HACK: temporarily removed, together with related unit-tests
    ,
    className: styles.announcement__service__icon__close,
    onClick: onClose
  }));
}